module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/badge-plan-a-7de909b8e335dcf1f7f64e10237a4ff9.svg";